import React from "react";
import Wrp from "../../../hoc/Wrp/Wrp";
import { isSet } from "../../../Utils/CommonFunctions";
import { getOutputFieldsElement, isValidJson } from "../MarkupFunctions";

const ScmOutputTextField = ({ attributes, elmtParams })=>{
    const {convertAndRenderElement} = elmtParams;
    const {loopData,dataTable,dynamicVar,children,childActionButtons} = elmtParams;

    const dataElmt = getOutputFieldsElement(attributes,elmtParams);
    let dataElmtStr;
    if (React.isValidElement(dataElmt)) {
      dataElmtStr = dataElmt;
    } else if (isValidJson(dataElmt)) {
      dataElmtStr = JSON.stringify(dataElmt);
    } else {
      dataElmtStr = dataElmt;
    }
    return React.createElement(
        Wrp, 
        {...attributes},
        convertAndRenderElement([{
                data:dataElmtStr,
                type:'text'
            },...isSet(children,[])],{
                loopData,
                dataTable,
                dynamicVar,
                childActionButtons}));
    
}

ScmOutputTextField.defaultProps = {
    attributes:{},
    elmtParams:{}
}
export default ScmOutputTextField;